import { resizeEcharts } from "./resizeEcharts";
import * as $echarts from 'echarts';

const resizeEchartsByDiv = (id, chartid, chartIdList) => {
    let chartDom = document.getElementById(id);
    chartIdList[chartid] = $echarts.init(chartDom);
    resizeEcharts(chartDom, chartIdList[chartid]);
}
export {
    resizeEchartsByDiv
}